<template>
    <!-- Карточка сотрудника -->
    <section class="gz-info-card">
        <!-- Данные о сотруднике -->
        <section class="gz-info-card__info">
            <span class="gz-info-card__item icon-hipster"></span>
            <span class="gz-info-card__item">
                <strong>Фамилия:&nbsp;</strong>{{ dataComputed.attributes ? dataComputed.attributes.lname : '' }}
            </span>
            <span class="gz-info-card__item">
                <strong>Имя:&nbsp;</strong>{{ dataComputed.attributes ? dataComputed.attributes.fname : '' }}
            </span>
            <span v-if="dataComputed.attributes && dataComputed.attributes.pname" class="gz-info-card__item">
                <strong>Отчество:&nbsp;</strong>{{ dataComputed.attributes.pname }}
            </span>
            <span v-if="dataComputed.attributes && dataComputed.attributes.phone" class="gz-info-card__item">
                <strong>Телефон:&nbsp;</strong>{{ dataComputed.attributes.phone }}
            </span>
            <span v-if="dataComputed.attributes && dataComputed.attributes.email" class="gz-info-card__item">
                <strong>Email:&nbsp;</strong>{{ dataComputed.attributes.email }}
            </span>
        </section>
    </section>
</template>

<script>
export default {
    name: 'StaffMemberCard',

    props: {
        data: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        dataComputed() {
            return this.data
        }
    }
}
</script>